<template>
    <!-- Page Header-->
    <Header :title="title" :subtitle="subtitle" />
    <!-- Main Content-->
    <main>
        <el-row justify="center">
            <el-col :xs="24" :sm="12">
                <el-card style="margin-bottom: 2rem;">
                    <p style="margin:0rem">世界观</p>
                    <el-checkbox-group v-model="checkedWorlds" @change="handleCheckedWorldsChange">
                        <el-checkbox v-for="world in worlds" :key="world" :label="world">{{ world
                        }}</el-checkbox>
                    </el-checkbox-group>
                    <p style="margin:0rem">性别</p>
                    <el-checkbox-group v-model="checkedSexes" @change="handleCheckedSexesChange">
                        <el-checkbox v-for="sex in sexes" :key="sex" :label="sex">{{ sex }}</el-checkbox>
                    </el-checkbox-group>
                    <el-button type="danger" @click="handleCheckAllChange">重置</el-button>
                </el-card>
                <div class="gallery-container">
                    <div class="row" v-if="charaList.length > 0">
                        <el-card @click="toDetail(c.name)" class="col-6 col-xl-3" v-for="c in charaList" :key="c.id"
                            shadow="hover" style="text-align: center;">
                            <template #footer>{{ c.name }}</template>
                            <el-image :src="'http://img.helloworldend.top/upload/' + c.img" style="width: 100%" />
                        </el-card>
                    </div>
                </div>
            </el-col>
        </el-row>
    </main>
</template>
<script setup>
import Header from '../components/Header.vue'
import { onMounted, ref } from 'vue'
import router from 'router'
import service from '../utils/request'
import { useCache } from '../utils/usecache'

const title = '角色介绍'
const subtitle = '想要了解谁呢？'

const allChara = ref([])
const checkAll = ref(false)
const checkedWorlds = ref(['泰尔兰大陆环游记', 'CSPA特别行动组行动报告', '狐狗狸大人摔倒了', '第八十亿零一种结局'])
const worlds = ['泰尔兰大陆环游记', 'CSPA特别行动组行动报告', '狐狗狸大人摔倒了', '第八十亿零一种结局']
const checkedSexes = ref(['男', '女'])
const sexes = ['男', '女']
const charaList = ref([])

const handleCheckAllChange = val => {
    checkedSexes.value = val ? sexes : []
    checkedWorlds.value = val ? worlds : []
    if (val) {
        charaList.value = allChara.value
    } else {
        charaList.value = []
    }
}

const handleCheckedWorldsChange = value => {
    const checkedCount = value.length
    checkAll.value = checkedCount === worlds.length
    let rst = []
    for (let i = 0; i < allChara.value.length; i++) {
        if (value.indexOf(allChara.value[i]['world']) !== -1) {
            rst.push(allChara.value[i])
        }
    }
    charaList.value = rst
}
const handleCheckedSexesChange = value => {
    const checkedCount = value.length
    checkAll.value = checkedCount === sexes.length
    let rst = []
    for (let i = 0; i < allChara.value.length; i++) {
        if (value.indexOf(allChara.value[i]['sex']) !== -1) {
            rst.push(allChara.value[i])
        }
    }
    charaList.value = rst
}

const getData = async () => {
    try {
        const rst = await useCache('charaListList', () => {
            return service.get("/user/chara/listList").then(res => res.data)
        })
        if (rst?.length && rst[0] != null) {
            charaList.value = rst
            allChara.value = rst
        } else {
            console.error('返回角色信息为空')
        }
    } catch (error) {
        console.error('获取角色信息失败', error)
    }
}

const toDetail = (name) => {
    router.push('/chara/' + name)
}

onMounted(() => {
    getData()
})
</script>
<style scoped></style>